"use strict";

require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.timers.js");
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _usePrefixCls = require("../_utils/hooks/usePrefixCls");
var _icons = require("../Icon/icons");
var _User = _interopRequireDefault(require("../User"));
var _excluded = ["className", "style", "children", "userProps", "minCollapsed", "active", "logoHref", "disabledlogoClick"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var AsideBar = function AsideBar(props) {
  var className = props.className,
    style = props.style,
    children = props.children,
    userProps = props.userProps,
    minCollapsed = props.minCollapsed,
    active = props.active,
    logoHref = props.logoHref,
    _props$disabledlogoCl = props.disabledlogoClick,
    disabledlogoClick = _props$disabledlogoCl === void 0 ? true : _props$disabledlogoCl,
    extraProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  // 是否收起
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    collapsed = _useState2[0],
    setCollapsed = _useState2[1];
  // 是否小屏幕
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    minScreen = _useState4[0],
    setMinScreen = _useState4[1];
  var prefixCls = (0, _usePrefixCls.usePrefixCls)('aside-bar');
  var classes = (0, _classnames2.default)(prefixCls, className);

  // 判断是否是小尺寸
  // const handleSize = value => value < 1200 && value >= 1024;
  var handleSize = function handleSize(value) {
    return value < 1200;
  };
  (0, _react.useEffect)(function () {
    // 1024-1200px之间收起右侧菜单
    if (!minCollapsed) {
      '';
      return;
    }
    // 判断屏幕的初始尺寸
    setMinScreen(handleSize(window.innerWidth));
    // 防抖函数处理，防止多次调用
    var timer;
    var handleResize = function handleResize() {
      if (timer) {
        clearTimeout(timer);
      }
      timer = setTimeout(function () {
        setMinScreen(handleSize(window.innerWidth));
      }, 500);
    };
    // 监听屏幕的变化
    window.addEventListener('resize', handleResize);
    // 移除屏幕的监听事件
    return function () {
      return window.removeEventListener('resize', handleResize);
    };
  }, []);
  (0, _react.useEffect)(function () {
    // 是小屏幕的话就自动收起
    setCollapsed(minScreen);
  }, [minScreen]);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames2.default)(classes, (0, _defineProperty2.default)({}, "".concat(prefixCls, "-is-collapsed"), collapsed), {
      'is-active': active
    }),
    style: style
  }, extraProps), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__hd")
  }, /*#__PURE__*/_react.default.createElement("a", {
    className: (0, _classnames2.default)("".concat(prefixCls, "__logo"), {
      'is-disabled-click': disabledlogoClick
    }),
    href: logoHref
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "icon-logo"
  }), /*#__PURE__*/_react.default.createElement("i", {
    className: "icon-logo-collapsed"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__bd")
  }, children), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames2.default)("".concat(prefixCls, "__ft"), {
      'is-minscreen': minScreen
    }, {
      'is-collapsed': collapsed
    })
  }, /*#__PURE__*/_react.default.createElement(_User.default, userProps), minScreen && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames2.default)("".concat(prefixCls, "__ft-fold")),
    onClick: function onClick() {
      setCollapsed(!collapsed);
    }
  }, /*#__PURE__*/_react.default.createElement(_icons.Arrowright24Icon, {
    style: {
      fontSize: 24
    }
  }))));
};
var _default = AsideBar;
exports.default = _default;